import * as React from 'react';

import { WhatsAroundListItem } from './list-item';

interface NearbyRestaurantsProps {
  nearbyRestaurantsList: string[];
}

export const NearbyRestaurants: React.FunctionComponent<NearbyRestaurantsProps> = ({ nearbyRestaurantsList }) => {
  const restaurantListItems = nearbyRestaurantsList.map((restaurant, index) => {
    const liKey = `restaurants-${index}`;
    if (!restaurant) {
      return null;
    }

    return (
      <WhatsAroundListItem
        category="local_dining"
        iconId={`whats-around-restaurants-category-${index}`}
        id={liKey}
        liClassName="retaurants__list-item"
        liContent={restaurant}
        key={liKey}
        displayIcons={false}
      />
    );
  });

  return (
    <ul className="restaurants__list uitk-type-list-300 icon-s all-l-padding-three" data-stid="whats-around-restaurants">
      {restaurantListItems}
    </ul>
  );
};
